interface Props {
  size?: number;
  color?: string;
}

export default function GrayscaleIcon({ size = 20, color = "currentColor" }: Props) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3V21Z" fill={color} />
      <circle cx="12" cy="12" r="9" stroke={color} strokeWidth="1.5" />
    </svg>
  );
}
